import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import AuthorityTableRow from 'Services/common/Features/Authority/Components/AuthorityTableRow/AuthorityTableRow'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import type { School } from 'Services/SchoolManagement/Features/School/types'
import useTypedSelector from 'Store'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography,
  useTheme
} from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface SchoolDetailsProps {
  school: School
}

export default function SchoolDetails({ school }: Readonly<SchoolDetailsProps>) {
  const { user } = useTypedSelector(state => state.user)

  const theme = useTheme()

  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          {isSuperuser(user) && <AuthorityTableRow pta={school.codespace_id} />}
          <StyledTableRow>
            <StyledTableCell>{t`School identifier`}</StyledTableCell>
            <TableCell>{school.school_id}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Name`}</StyledTableCell>
            <TableCell>
              {school.name}
              <Typography variant="body2" color={theme.palette.text.secondary}>
                {school.school_unit_id}
              </Typography>
            </TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Calendar`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(school.school_calendar?.name)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(school.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(school.modified_timestamp)}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
